import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import { useOpenDeeplink } from 'shared/src/hooks';
import { isNotNil } from 'shared/src/utils';
import type { LikedGoodsPrimaryCardEntity } from 'shared/src/api';

interface PrimaryCardItemProps {
  entity: LikedGoodsPrimaryCardEntity;
  width: number;
}

/**
 * iOS `MetaFeedPrimaryCardCell` 대응.
 * 찜 상품 그리드 사이에 끼어드는 프로모션 카드 (1슬롯 = 1/3 너비).
 */
export const PrimaryCardItem = ({ entity, width }: PrimaryCardItemProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const { item } = entity;

  const handlePress = () => {
    if (isNotNil(item.link)) openDeeplink(item.link);
  };

  return (
    <Flex
      width={width}
      backgroundColor={'bg_secondary'}
      borderRadius={4}
      onPress={handlePress}
    >
      <RemoteImage
        uri={item.image.url}
        width={width}
        height={width * (item.image.ratio || 1)}
        borderRadius={'medium'}
        doAnimate={item.image.use_animation}
      />
      <Flex padding={{ horizontal: 8, vertical: 8 }} gap={4}>
        <Typography type={'subtitle3'} numberOfLines={1}>
          {item.title}
        </Typography>
        {isNotNil(item.content) && (
          <Typography
            type={'body4'}
            color={'content_tertiary'}
            numberOfLines={2}
          >
            {item.content}
          </Typography>
        )}
        {isNotNil(item.button) && (
          <Flex
            margin={{ top: 4 }}
            padding={{ horizontal: 8, vertical: 4 }}
            backgroundColor={'bg_primary'}
            borderRadius={4}
            alignItems={'center'}
          >
            <Typography type={'subtitle4'} color={'content_secondary'}>
              {item.button}
            </Typography>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
